<template>
    <div class="lang">
        <div class="process">
            <div class="info on">
                <ul class="step-box">
                    <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Захиалга</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Бэлтгэх зүйл хүлээн авах болон захиалга баталгаажуулахаар утсаар ярих</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Бүртгэл</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Эмчтэй уулзаж зөвлөгөө авах</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Төлбөр төлөх</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 06</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Шинжилгээ өгөх</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 07</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Шинжилгээ дуусах, захиалга өгөх</h4>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="info">
                <h3 class="bullet01">Захиалга</h3>
                <p class="bullet03 depth">Утсаар захиалга өгөх: 02-6986-2222~4</p>
                <p class="bullet03 depth">Төвд ирж захиалга өгөх: И-Хуа их сургуулийн Сөүл салбар эмнэлгийн C барилга 3-р давхар, Велнес Эрүүл мэндийг дэмжих төвийн мэдээллийн лавлах</p>
                <p class="bullet03 depth">Интернет захиалга : Доорх товчлуур дээр дарж интернэтээр захиалга өгөх боломжтой</p>
                <p class="bullet03 depth">Эмчээс зөвлөгөө авах цаг : Ажлын өдөр 09:00~17:00 цаг. Ажлын өдөр(бямба, ням, нийтийн амралтын өдрөөс бусад өдөр) Шинжилгээ өгөх өдөр тогтоогдвол мэргэжлийн сувилагч утсаар холбогдоно. Шинжилгээний захиалга
                    өгөхдөө ууж байгаа эмийнхээ талаар урьдчилан мэдээлнэ үү</p>

                <div class="botton-wrap"><a href="" class="main-button c-main">томилгоо</a></div>
            </div>
            <div class="info">
                <h3 class="bullet01">Бэлтгэх зүйл хүлээн авах болон захиалга баталгаажуулахаар утсаар ярих</h3>
                <p class="bullet03 depth">Шинжилгээ хийлгэх захиалга өгсний дараа шинжилгээний багцын мэдээлэл болон бэлтгэх зүйлийг хүлээн авна.</p>
                <p class="bullet03 depth">Шинжилгээ хийлгэхээс 1 долоо хоногийн өмнө захиалгыг баталгаажуулахаар утсаар (хэппи кал) холбогдоно.</p>
                <p class="bullet03 depth">Шинжилгээ өгөхөөс 1 өдрийн өмнө гар утсаар мэдэгдэл зурвас(SMS) илгээнэ.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Бүртгэл</h3>
                <p class="bullet03 depth">Велнес Эрүүл мэндийг дэмжих төвийн мэдээллийн лавлах дээр очиж захиалгаа баталгаажуулан бүртгүүлнэ.</p>
                <p class="bullet03 depth">Бэлтгэсэн зүйлээ өгнө(эрүүл мэндийн асуулгын хуудас, өтгөний сорьц гэх мэт).</p>
                <p class="bullet03 depth">Шинжилгээний нэр төрөл болон хийлгэх шат дарааллыг хэлж өгнө</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Эмчтэй уулзаж зөвлөгөө авах</h3>
                <p class="bullet03 depth">Шинжилгээ хийлгэхийн өмнө эмчтэй уулзан зөвлөгөө авч, эрүүл мэндийн асуулгын хуудас, зөвшөөрлийн хуудас бөглөнө.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Төлбөр төлөх</h3>
                <p class="bullet03 depth">Эрүүл мэндийн шинжилгээний төлбөр төлнө.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Шинжилгээ хийлгэх</h3>
                <p class="bullet03 depth">Хувцсаа тайлж шинжилгээ хийлгэхэд өмсдөг хувцас болон таавчиг өмсөнө(бүх гоёл чимэглэл, үнэ цэнэтэй зүйлсээ тусад нь хадгалуулах боломжтой),</p>
                <p class="bullet03 depth">Багц шинжилгээний хөтөлбөрийн дагуу шинжилгээг хийнэ(Багцаас хамаарч шинжилгээ 3~6 цаг үргэлжилнэ)</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Шинжилгээ дуусах</h3>
                <p class="bullet03 depth">Гэртээ харьсны дараа анхаарах зүйлийг хэлж өгнө(хоолны тасалбар олгоно).</p>
                <p class="bullet03 depth">Шинжилгээний хариу авах өдрөө захиалах: Төвд ирж эмчтэй уулзах уу, шуудангаар хариугаа авах уу гэдгээ сонгоно.</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>